import React from 'react'

interface SanitySvgIconProps {
  svgCode: string | undefined
  className?: string
  size?: 'sm' | 'md' | 'lg' | 'xl'
}

export function SanitySvgIcon({ svgCode, className = '', size = 'md' }: SanitySvgIconProps) {
  if (!svgCode) {
    // Fallback icon when no SVG is provided
    return (
      <div className={`inline-flex items-center justify-center ${getSizeClass(size)} ${className}`}>
        <svg
          className="h-full w-full"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M12 6v6m0 0v6m0-6h6m-6 0H6"
          />
        </svg>
      </div>
    )
  }

  // Process the SVG to replace hardcoded colors with currentColor
  // This ensures icons inherit the text color from their parent
  const processedSvg = svgCode
    // Replace hex colors with currentColor
    .replace(/fill="(#[0-9a-fA-F]{3,8}|rgb[a]?\([^)]+\))"/gi, 'fill="currentColor"')
    .replace(/fill='(#[0-9a-fA-F]{3,8}|rgb[a]?\([^)]+\))'/gi, 'fill="currentColor"')
    .replace(/stroke="(#[0-9a-fA-F]{3,8}|rgb[a]?\([^)]+\))"/gi, 'stroke="currentColor"')
    .replace(/stroke='(#[0-9a-fA-F]{3,8}|rgb[a]?\([^)]+\))'/gi, 'stroke="currentColor"')
    // Remove width and height attributes to make SVG responsive
    .replace(/width="[^"]*"/gi, '')
    .replace(/height="[^"]*"/gi, '')
    // Add viewBox if it doesn't exist (fallback to 24x24)
    .replace(/<svg(?![^>]*viewBox)/i, '<svg viewBox="0 0 24 24"')
    // Add class for styling
    .replace(/<svg/i, `<svg class="h-full w-full"`)

  return (
    <div 
      className={`inline-flex items-center justify-center ${getSizeClass(size)} ${className}`}
      dangerouslySetInnerHTML={{ __html: processedSvg }}
    />
  )
}

// Helper function to get size classes
function getSizeClass(size: 'sm' | 'md' | 'lg' | 'xl'): string {
  switch (size) {
    case 'sm':
      return 'h-4 w-4'
    case 'md':
      return 'h-6 w-6'
    case 'lg':
      return 'h-8 w-8'
    case 'xl':
      return 'h-12 w-12'
    default:
      return 'h-6 w-6'
  }
}